/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-10-27",
    versionChannel: "nightly",
    buildDate: "2024-10-27T00:06:26.964Z",
    commitHash: "3464ad731d65ed9ae44ee37f853176ea62ed5446",
};
